import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { PrimeNGConfig, MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { DmsFile } from '../../modal/upload/model/upload.model';
import { UploadService } from '../../services/upload/upload.service';

@Component({
  selector: 'app-concurrence-rfi',
  standalone:false,
  templateUrl: './concurrence-rfi.component.html',
  styleUrl: './concurrence-rfi.component.scss'
})
export class ConcurrenceRfiComponent implements OnInit, OnDestroy, AfterViewInit {
  RFPForm: FormGroup;
  uploadedFiles: File[] = [];
  @Input() proposalName: any;
  @Input() proposalId: any;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() step: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  uploadedFileName: string = '';
  file: File;
  @Input() id: any;

  private subscriptions = new Subscription();
  userID: any;
  allDmsFiles: any[]=[];

  constructor(private fb: FormBuilder, private config: PrimeNGConfig, 
    private messageService: MessageService, private api: ApiService, 
    private uploadService: UploadService, private route: ActivatedRoute) {
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
   }

  ngOnInit(): void {
    this.RFPForm = this.fb.group({
      justification: ['', Validators.required],
    });
    this.getRfpDetails()
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.RFPForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.RFPForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
      editorReady = false;
  rebuildEditor() {
  this.editorReady = false; // destroy
  setTimeout(() => {
    this.init = this.getTinyInit(); // refresh config
    this.editorReady = true; // recreate editor
  }, 0);
}
getTinyInit(): EditorComponent['init'] {
  return {
    readonly: this.isEditorDisabled
  };
}
  goToNextStep() {
    this.stepCompleted.emit();
  }
  rfpdata: any;
  getRfpDetails() {
    const sub = this.api.getAPI(`/tdf/concurrence/rfi/?proposal_step=${this.id}&proposal_step__proposal=${this.proposalId}`).subscribe((res: any) => {
      this.rfpdata = res;
      console.log('this is concurrence rfi', this.rfpdata,res);
      const dmsFiles: DmsFile[] = this.rfpdata.dms_files;
      this.allDmsFiles = dmsFiles;
      // this.uploadedUrl = res[0].file || null;
      this.RFPForm.patchValue({
        justification: this.rfpdata?.justification
      });
    });
    this.subscriptions.add(sub);
  }

    // this is use for upload document table
  onDocumentUpload(data: any) {
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    // ✅ Use your service method here
    this.uploadService.uploadneedGenData(formData).subscribe({
      next: (res: any) => {
        console.log('>>>>>>res need upload data', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    });

  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('description', updatedDoc.description);

    // Only append file if it's a new file (File object)
    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    // ✅ Update API call
    this.uploadService.updateUploadNeedGenData(updatedDoc.id, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);

        // ✅ Replace the updated record instead of pushing new
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          // Update the existing record
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);

    this.uploadService.deleteUploadNeedGenData(docId).subscribe({
      next: (res: any) => {
        console.log('delete uploadData', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    })

    // Optionally call delete API
  }

  onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }

  onSubmit(): void {
    // if (this.commentForm.valid) {
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('justification', this.RFPForm.get('justification').value);
    if (this.file) {
      formData.append('file', this.file);
    }

    if (this.rfpdata) {
      console.log("hitting put api");
      const sub = this.api.putAPI(`/tdf/concurrence/rfi/${this.rfpdata.id}/`, formData).subscribe((res: any) => {
        this.getRfpDetails();
        this.uploadedUrl = null
         this.uploadedFileName = ''
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data updated successfully' });
      });
      this.subscriptions.add(sub);

    } else {
      const sub = this.api.postAPI('/tdf/concurrence/rfi/', formData).subscribe((res: any) => {
        console.log("hitting post api");
        this.getRfpDetails();
         this.uploadedUrl = null;
        this.uploadedFileName = ''
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'SSCT uploaded successfully' });
      });
      this.subscriptions.add(sub);
    }
    // } else {
    //   this.commentForm.markAllAsTouched();
    // }
  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.proposalName },
        { key: "Justification", value: this.RFPForm.get('justification')?.value },
      ]
    }
    this.generatePDFEmitter.emit(payload);
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 35 ? fileName.substring(0, 30) + '...' : fileName;
  }
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    // this.uploadedUrl = null;
    fileUpload.clear();
  }

  
//    visible: boolean = false;
//   confirmChecked=false;

//   showConfirm() {
//       if (!this.visible) {
//           this.confirmChecked = false; // Reset checkbox when opening the modal
//           this.messageService.add({ key: 'confirm', sticky: true, severity: 'info', summary: 'Are you sure you want to submit this proposal?' });
//           this.visible = true;
//       }
//   }

//     onReject() {
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.confirmChecked = false; // Reset checkbox when closing the modal
//   }
// submitIRA() {
//   const iraPayload = {
//     proposal_step: this.id, // Using the component's id which seems to be proposal_step
//     // user: this.userID, // From your component
//     // user : parseInt(this.userID),
//     user : sessionStorage.getItem('user_id'),
//     approve_status: 1, // 1 for accept, 2 for reject
//     final_approval: this.confirmChecked ? 1 : 0, // Convert boolean to 1/0
//     remark: "", 
//     unit: sessionStorage.getItem('unit_id'),
    
//     // unit: this.challengeForm.get('coordinatingAgency')?.value || 2 // Using coordinating agency or default
//   };
//   console.log("unit id is", iraPayload.unit);
//   const sub = this.api.postAPI('/transaction/copy/proposal-ira-action/',
//     iraPayload
//   ).subscribe({
//     next: (response: any) => {
//       this.messageService.add({
//         severity: 'success',
//         summary: 'Success',
//         detail: 'IRA action submitted successfully',
//       });
//       // Emit the IRA data if needed by parent component
//       this.IRA.emit(response);
//       console.log('IRA submission response:', response);
//     },
//     error: (err) => {
//       console.error('IRA submission failed:', err);
//       this.messageService.add({
//         severity: 'error',
//         summary: 'Error',
//         detail: 'Failed to submit IRA action',
//       });
//     }
//   });
  
//   this.subscriptions.add(sub);
// }
//   onConfirm() {
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.onSubmit(); 
//       console.log("hiiiii")
//       this.submitIRA();
//       this.routeConfig.emit({isRouteConfig: true, isFinalApproval: this.confirmChecked});
//   }

 
//    routeconfig() {
//       console.log('routeconfig');
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.confirmChecked = false; // Reset checkbox when closing the modal
//       this.routeConfig.emit({isRouteConfig: false});
//   }

}
